export enum Segments {
  ROLE = 'role',
}

export enum SegmentTypes {
  LEAVE = 'leave',
}
